"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var _popper = _interopRequireDefault(require("./popper"));
var _popoverBody = _interopRequireDefault(require("./popover-body"));
var _popoverHeader = _interopRequireDefault(require("./popover-header"));
var _popoverContent = _interopRequireDefault(require("./popover-content"));
const parts = ['popper', 'content', 'header', 'body'];
const baseStyle = props => ({
  header: _popoverHeader.default,
  content: (0, _popoverContent.default)(props),
  body: (0, _popoverBody.default)(props),
  popper: _popper.default
});
var _default = exports.default = (0, _merge.default)(_theme.default.components.Popover, {
  parts,
  baseStyle
});